import { render, staticRenderFns } from "./aluno-anoLectivo.vue?vue&type=template&id=129b93c5&"
import script from "./aluno-anoLectivo.vue?vue&type=script&lang=js&"
export * from "./aluno-anoLectivo.vue?vue&type=script&lang=js&"
import style0 from "./aluno-anoLectivo.vue?vue&type=style&index=0&id=129b93c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports